import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
      maxWidth: 300,
      marginBottom: "5%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    media: {
      height: 140,
    },
    qty:{
        marginTop : "40%",
    },
  });

export default useStyles;